import { createWithEqualityFn } from 'zustand/traditional';
import { NoteType } from '@models/note';

type MessageDraftState = {
  drafts: Record<string, string>;
  saveDraft: (key: string, serializedContent: string) => void;
  clearDraft: (key: string) => void;
  clearDraftsForQuote: (quoteId: string) => void;
};

export const composeDraftKey = (quoteId: string, type: NoteType) => `${quoteId}:${type}`;

export const useMessageDraftStore = createWithEqualityFn<MessageDraftState>()((set) => ({
  drafts: {},
  saveDraft: (key, serializedContent) =>
    set((state) => {
      if (state.drafts[key] === serializedContent) return state;
      return { drafts: { ...state.drafts, [key]: serializedContent } };
    }),
  clearDraft: (key) =>
    set((state) => {
      const next = { ...state.drafts };
      delete next[key];
      return { drafts: next };
    }),
  clearDraftsForQuote: (quoteId) =>
    set((state) => {
      const next = { ...state.drafts };
      Object.values(NoteType).forEach((type) => {
        delete next[composeDraftKey(quoteId, type)];
      });
      return { drafts: next };
    }),
}));
